<app-navbar title="Konta bankowe">
	<button class="btn btn-primary" (click)="dialogOpen()"><i class="fas fa-plus"></i> Dodaj</button>
</app-navbar>

<div class="modal" id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="modal-body">
				<div class="form-floating mb-3">
					<input
						type="text"
						class="form-control"
						id="name"
						name="addNumber"
						[(ngModel)]="addNumber"
						placeholder="xx xxxx xxxx xxxx xxxx xxxx xxxx"
						required
					/>
					<label for="addNumber">Numer konta</label>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="submit()">Zapisz</button>
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dialogClose()">
					Anuluj
				</button>
			</div>
		</div>
	</div>
</div>

<app-dynamic-table [elements]="data" [tableRows]="tableRows" module="bankAccounts"></app-dynamic-table>
